export default __webpack_public_path__ + "static/Market-53edd223c947bec4a126ade1f763037c.png";